import { X, Heart, BookmarkCheck, Utensils } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const SavedRecipesModal = ({
  showSaved,
  setShowSaved,
  savedRecipes,
  toggleSaveRecipe,
  setSelectedRecipe,
}) => {
  return (
    <Dialog open={showSaved} onOpenChange={setShowSaved}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-auto bg-[#FEFAE0] border-0 p-0 rounded-3xl" aria-describedby={undefined}>
        <div className="p-6" data-testid="saved-recipes-modal">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-[#264653] flex items-center gap-2">
              <Heart className="w-6 h-6 text-[#E76F51] fill-[#E76F51]" />
              Saved Recipes
            </DialogTitle>
          </DialogHeader>

          {savedRecipes.length === 0 ? (
            <div className="text-center py-8">
              <BookmarkCheck className="w-12 h-12 text-[#264653]/20 mx-auto mb-3" />
              <p className="text-[#264653]/60">No saved recipes yet</p>
              <p className="text-sm text-[#264653]/40 mt-1">Tap the heart icon to save recipes</p>
            </div>
          ) : (
            <div className="space-y-3 mt-4">
              {savedRecipes.map((recipe, index) => (
                <div
                  key={recipe.id}
                  className="bg-white rounded-2xl p-3 flex items-center gap-3 border-2 border-[#264653]/10 cursor-pointer hover:border-[#264653]/30"
                  onClick={() => { setSelectedRecipe(recipe); setShowSaved(false); }}
                  data-testid={`saved-recipe-${index}`}
                >
                  {recipe.image_url ? (
                    <img src={recipe.image_url} alt={recipe.title} className="w-16 h-16 rounded-xl object-cover" />
                  ) : (
                    <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-[#FFB703]/20 to-[#2A9D8F]/20 flex items-center justify-center">
                      <Utensils className="w-6 h-6 text-[#264653]/30" />
                    </div>
                  )}
                  <div className="flex-1 min-w-0">
                    <h4 className="font-bold text-[#264653] truncate">{recipe.title}</h4>
                    <div className="flex items-center gap-2 text-sm text-[#264653]/60">
                      <span>{recipe.time_minutes} min</span>
                      <span>•</span>
                      <span>{recipe.calories} cal</span>
                    </div>
                  </div>
                  <button
                    onClick={(e) => toggleSaveRecipe(recipe, e)}
                    className="w-8 h-8 rounded-full bg-[#E76F51]/10 flex items-center justify-center text-[#E76F51] hover:bg-[#E76F51] hover:text-white"
                    data-testid={`remove-saved-${index}`}
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
